import React, { useEffect, useState } from 'react';
import MasterLayout from '../../layouts/MasterLayout';
import ThemeBreadcrumb from '../../components/themes/ThemeBreadcrumb';
import AppNotification from '../../helpers/AppNotification';
import Paginate from '../../components/paginate/Paginate';
import PackageModel from '../../models/PackageModel';
import HomeAdminCardMoney from "../../components/homeAdmin/HomeAdminCardMoney";
import ComboModel from '../../models/ComboModel';
import Swal from 'sweetalert2';


function PackagePage(props) {
    const [refreshKey, setRefreshKey] = useState(0);
    // paginate
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState({});
    const changePage = (page) => {
        setPage(page);
    }
    const handleSetPage = (number) => {
        setPage(page + number);
    }

    const [data, setData] = useState([]);
    const [type, setType] = useState('');
    const [isExpired, setIsExpired] = useState('');
    const [bank, setBank] = useState('');
    const [keyword, setKeyword] = useState('');
    const [filter, setFilter] = useState({
        search: '',
        type: '',
        bank: '',
        perPage: perPage,
        page: page,
    });

    const handleChangeperPage = (e) => {
        setPerPage(e.target.value);
        setPage(1);
    }

    const handleChange = (event) => {
        setKeyword(event.target.value);
    };

    const handleChangeType = (event) => {
        setType(event.target.value);
    };

    const handleChangeIsExpired = (event) => {
        setIsExpired(event.target.value);
    };

    const handleChangeBank = (event) => {
        setBank(event.target.value);
    };

    const resetFilter = (event) => {
        setType('');
        setIsExpired('');
        setFilter({ search: '' });
        setPage(1);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setFilter({ search: keyword });
    }

    useEffect(() => {
        PackageModel.getReport(
            {
                search: filter.search,
                type: type,
                page: page,
                isExpired: isExpired,
                perPage: perPage,
                bank: bank
            }
        ).then((res) => {
            setData(res.data);
            setMeta(res.meta);
        }).catch((err) => {
            console.log(err);
            AppNotification.showError('Lấy dữ liệu thất bại!');
        })
    }, [page, filter, refreshKey]);

    
    const handleAdminRenew = (bankId, bankLabel, userName, currentEndDay) => {
        Swal.fire({
            title: 'Gia Hạn Tài Khoản Hộ User',
            html: `
                <div style="text-align: left; font-size: 13.5px; color: #cbd5e1; line-height: 1.6;">
                    <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px; margin-bottom: 14px; border: 1px solid rgba(255,255,255,0.1);">
                        <div>Tài khoản STK: <b style="color: #38bdf8;">${bankLabel || '---'}</b></div>
                        ${userName ? `<div>User sở hữu: <b style="color: #f59e0b;">${userName}</b></div>` : ''}
                        <div>Hạn hiện tại: <b style="color: #ef4444;">${currentEndDay || 'Chưa thiết lập'}</b></div>
                    </div>

                    <label style="display: block; font-weight: 600; margin-bottom: 8px; color: #f8fafc;">1. Chọn thời gian gia hạn thêm:</label>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 10px;" id="swal-duration-grid">
                        <button type="button" class="swal-plan-btn" data-days="7" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">+7 Ngày (1 tuần)</button>
                        <button type="button" class="swal-plan-btn active" data-days="30" style="padding: 9px; border: 2px solid #10b981; background: #064e3b; color: #6ee7b7; border-radius: 6px; font-weight: 600; cursor: pointer; font-size: 13px;">+30 Ngày (1 tháng)</button>
                        <button type="button" class="swal-plan-btn" data-days="90" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">+90 Ngày (3 tháng)</button>
                        <button type="button" class="swal-plan-btn" data-days="365" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">+365 Ngày (1 năm)</button>
                        <button type="button" class="swal-plan-btn" data-days="9999" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">Vĩnh viễn (đến 2030)</button>
                        <button type="button" class="swal-plan-btn" data-days="custom" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">Tuỳ chỉnh số ngày...</button>
                    </div>

                    <div id="swal-custom-days-wrap" style="display: none; margin-bottom: 12px;">
                        <label style="font-size: 12px; color: #94a3b8; display: block; margin-bottom: 4px;">Nhập số ngày muốn cộng thêm:</label>
                        <input type="number" id="swal-custom-days" min="1" max="5000" placeholder="Ví dụ: 15, 60..." style="width: 100%; padding: 8px 10px; background: #0f172a; border: 1px solid #334155; border-radius: 6px; color: #fff; font-size: 13px;" />
                    </div>

                    <label style="display: block; font-weight: 600; margin-bottom: 8px; margin-top: 14px; color: #f8fafc;">2. Hình thức tính phí:</label>
                    <div style="background: rgba(255,255,255,0.03); padding: 10px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08);">
                        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; margin-bottom: 8px;">
                            <input type="radio" name="swal_fee_type" value="free" checked style="accent-color: #10b981;" />
                            <span><b>Admin tặng / Miễn phí</b> <span style="font-size: 12px; color: #94a3b8;">(Cộng thẳng hạn, không trừ của user)</span></span>
                        </label>
                        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; margin-bottom: 0;">
                            <input type="radio" name="swal_fee_type" value="combo" style="accent-color: #f59e0b;" />
                            <span><b style="color: #fbbf24;">Trừ Quỹ VIP của User</b> <span style="font-size: 12px; color: #94a3b8;">(Trừ số ngày VIP tương ứng trong ví user)</span></span>
                        </label>
                    </div>
                </div>
            `,
            background: '#111827',
            color: '#f8fafc',
            showCancelButton: true,
            confirmButtonText: 'Xác Nhận Gia Hạn',
            cancelButtonText: 'Đóng',
            confirmButtonColor: '#10b981',
            cancelButtonColor: '#475569',
            didOpen: () => {
                const buttons = document.querySelectorAll('.swal-plan-btn');
                const customWrap = document.getElementById('swal-custom-days-wrap');
                const customInput = document.getElementById('swal-custom-days');

                buttons.forEach(btn => {
                    btn.addEventListener('click', () => {
                        buttons.forEach(b => {
                            b.style.border = '1px solid #475569';
                            b.style.background = '#1e293b';
                            b.style.color = '#fff';
                            b.style.fontWeight = 'normal';
                            b.classList.remove('active');
                        });
                        btn.classList.add('active');
                        btn.style.border = '2px solid #10b981';
                        btn.style.background = '#064e3b';
                        btn.style.color = '#6ee7b7';
                        btn.style.fontWeight = '600';

                        const d = btn.getAttribute('data-days');
                        if (d === 'custom') {
                            customWrap.style.display = 'block';
                            customInput.focus();
                        } else {
                            customWrap.style.display = 'none';
                        }
                    });
                });
            },
            preConfirm: () => {
                const activeBtn = document.querySelector('.swal-plan-btn.active');
                let days = activeBtn ? activeBtn.getAttribute('data-days') : '30';
                if (days === 'custom') {
                    const customVal = parseInt(document.getElementById('swal-custom-days').value, 10);
                    if (!customVal || customVal <= 0) {
                        Swal.showValidationMessage('Vui lòng nhập số ngày hợp lệ!');
                        return false;
                    }
                    days = customVal;
                } else {
                    days = parseInt(days, 10);
                }

                const feeTypeRadio = document.querySelector('input[name="swal_fee_type"]:checked');
                const deductCombo = feeTypeRadio && feeTypeRadio.value === 'combo';

                return { days, deductCombo };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                Swal.fire({
                    title: 'Đang xử lý...',
                    text: 'Hệ thống đang gia hạn và đồng bộ dữ liệu',
                    allowOutsideClick: false,
                    background: '#111827',
                    color: '#fff',
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                ComboModel.adminRenewBankAccount({
                    user_bank_account_id: bankId,
                    days: result.value.days,
                    deduct_combo: result.value.deductCombo ? 1 : 0
                }).then(res => {
                    if (res.success || res.status) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Gia hạn thành công!',
                            text: res.message || 'Tài khoản đã được cập nhật hạn mới thành công!',
                            background: '#111827',
                            color: '#fff',
                            confirmButtonColor: '#10b981'
                        });
                        setRefreshKey(prev => prev + 1);
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Thất bại!',
                            text: res.message || 'Có lỗi xảy ra khi gia hạn',
                            background: '#111827',
                            color: '#fff',
                            confirmButtonColor: '#e11d48'
                        });
                    }
                }).catch(err => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Lỗi!',
                        text: err?.response?.data?.message || err?.message || 'Không thể kết nối đến máy chủ!',
                        background: '#111827',
                        color: '#fff',
                        confirmButtonColor: '#e11d48'
                    });
                });
            }
        });
    };

    const handleResetExpiry = (bankId, days, label) => {
        Swal.fire({
            title: `Reset hạn về còn ${days} ngày?`,
            text: `Tài khoản ${label || ''} sẽ được đổi ngày hết hạn về còn ${days} ngày kể từ thời điểm này!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Đồng ý (${days} ngày)`,
            cancelButtonText: 'Hủy',
            confirmButtonColor: '#e11d48'
        }).then((result) => {
            if (result.isConfirmed) {
                ComboModel.adminResetBankExpiry({
                    user_bank_account_id: bankId,
                    days: days
                }).then(res => {
                    Swal.fire({
                        icon: 'success',
                        title: res.message || `Đã reset về ${days} ngày thành công!`,
                        timer: 2000,
                        showConfirmButton: true
                    });
                    setRefreshKey(prev => prev + 1);
                }).catch(err => {
                    Swal.fire({
                        icon: 'error',
                        title: err.response?.data?.message || 'Reset hạn thất bại!'
                    });
                });
            }
        });
    };

    const [totalAppMB, setTotalAppMB] = useState(0);
    const [totalAppMBPro, setTotalAppMBPro] = useState(0);
    const [totalAppVCB, setTotalAppVCB] = useState(0);
    const [totalAppBIDV, setTotalAppBIDV] = useState(0);
    const [totalAppICB, setTotalAppICB] = useState(0);
    const [totalAppTCB, setTotalAppTCB] = useState(0);
    const [totalAppTPB, setTotalAppTPB] = useState(0);
    const [totalBillVip1, setTotalBillVip1] = useState(0);
    const [totalBillVip2, setTotalBillVip2] = useState(0);
    const [totalBillVip3, setTotalBillVip3] = useState(0);

    useEffect(() => {
        PackageModel.getTotal().then((res) => {
            setTotalAppMB(res.total_app_mb);
            setTotalAppMBPro(res.total_app_mbpro);
            setTotalAppVCB(res.total_app_vcb);
            setTotalAppBIDV(res.total_app_bidv);
            setTotalAppICB(res.total_app_icb);
            setTotalAppTCB(res.total_app_tcb);
            setTotalAppTPB(res.total_app_tpb);
            setTotalBillVip1(res.total_bill_vip1);
            setTotalBillVip2(res.total_bill_vip2);
            setTotalBillVip3(res.total_bill_vip3);
        }).catch((err) => {
            console.log(err);
            AppNotification.showError('Lấy dữ liệu thất bại!');
        })
    }, [])

    return (
        <MasterLayout>
            <ThemeBreadcrumb title="Thống kê tài khoản app / gói bill" />
            <div className='row'>
                <div className='col-xl-12'>
                    <div className='row'>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng tài khoản App MB :'} value={totalAppMB} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng tài khoản App MB-Pro :'} value={totalAppMBPro} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng tài khoản App VCB :'} value={totalAppVCB} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng tài khoản App BIDV :'} value={totalAppBIDV} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng tài khoản App VietinBank :'} value={totalAppICB} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng tài khoản App TCB :'} value={totalAppTCB} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng tài khoản App TPBank :'} value={totalAppTPB} />
                        </div>
                    </div>
                </div>
                <div className='col-xl-12'>
                    <div className='row'>
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng gói Bill Vip1 :'} value={totalBillVip1} />
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng gói Bill Vip2 :'} value={totalBillVip2} />
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng gói Bill Vip3 :'} value={totalBillVip3} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Thống kê tài khoản App/Bill</h4>
                        </div>
                        <div className="card-body">
                            <div className='table-responsive'>
                                <div id="example3_wrapper" className="dataTables_wrapper no-footer">
                                    <div className='row mb-3'>
                                        <div className='col-md-3 d-flex align-items-end'>
                                            <div className="dataTables_length" id="example3_length">
                                                <label>
                                                    Hiển thị{" "}
                                                    <select
                                                        name="example3_length"
                                                        aria-controls="example3"
                                                        className=""
                                                        value={perPage}
                                                        onChange={(e) => handleChangeperPage(e)}
                                                    >
                                                        <option value={1}>1</option>
                                                        <option value={25}>25</option>
                                                        <option value={100}>100</option>
                                                    </select>{" "}
                                                    dữ liệu.
                                                </label>
                                            </div>
                                        </div>
                                        <div className='col-md-9 col-12 d-flex justify-content-end'>
                                            <form className='w-100' onSubmit={handleSubmit}>
                                                <div className='row justify-content-end'>
                                                    <div className='col-md-3 col-12 mb-2'>
                                                        <label className=''>Tìm kiếm : </label>
                                                        <input
                                                            type='text'
                                                            className='form-control ms-2'
                                                            placeholder='Tên tài khoản'
                                                            name='user_name'
                                                            value={keyword.search_text}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className='col-md-2 col-12'>
                                                        <label className=''>Loại : </label>
                                                        <select
                                                            name="type"
                                                            className="form-control form-control-new"
                                                            value={type}
                                                            onChange={handleChangeType}
                                                        >
                                                            <option value="">Chọn loại gói</option>
                                                            <option value={1}>Tài khoản ngân hàng</option>
                                                            <option value={2}>Gói package bill</option>
                                                        </select>
                                                    </div>

                                                    <div className='col-md-2 col-12'>
                                                        <label className=''>Tình trạng : </label>
                                                        <select
                                                            name="isExpired"
                                                            className="form-control form-control-new"
                                                            value={isExpired}
                                                            onChange={handleChangeIsExpired}
                                                        >
                                                            <option value="">Chọn tình trạng</option>
                                                            <option value={1}>Còn hạn</option>
                                                            <option value={2}>Hết hạn</option>
                                                        </select>
                                                    </div>

                                                    {type == 1 && (
                                                        <div className='col-md-3 col-12'>
                                                            <label className=''>Ngân hàng : </label>
                                                            <select
                                                                name="bank"
                                                                className="form-control form-control-new"
                                                                value={bank}
                                                                onChange={handleChangeBank}
                                                            >
                                                                <option value="">Chọn ngân hàng</option>
                                                                <option value="VCB">Ngân hàng Ngoại thương Việt Nam (Vietcombank)</option>
                                                                <option value="VCB-PRO">Ngân hàng Ngoại thương Việt Nam (Vietcombank) (Priority)</option>
                                                                <option value="TCB">Ngân hàng TMCP Kỹ thương Việt Nam (Techcombank)</option>
                                                                <option value="BIDV">Ngân hàng Đầu tư và Phát triển Việt Nam (BIDV)</option>
                                                                <option value="MB">Ngân hàng Quốc tế Việt Nam (MB)</option>
                                                                <option value="MB-PRO">Ngân hàng Quốc tế Việt Nam (MB) (Priority)</option>
                                                                <option value="ICB">Ngân hàng TMCP Công thương Việt Nam</option>
                                                                <option value="TPB">Ngân hàng TMCP TPBank</option>
                                                            </select>
                                                        </div>
                                                    )}

                                                    <div className='col-md-3 col-12 d-flex flex-column justify-content-end mb-2'>
                                                        <div className='input-group-append'>
                                                            <button className='btn light btn-light ms-2'
                                                                type='submit'>
                                                                Tìm kiếm
                                                            </button>
                                                            <button onClick={resetFilter} className='btn light btn-danger ms-2'
                                                                type='button'>
                                                                Xóa
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <table
                                        id="example3"
                                        className="display dataTable no-footer mb-2"
                                        style={{ width: '100%' }}
                                        role="grid"
                                        aria-describedby="example3_info"
                                    >
                                        <thead>
                                            <tr role="row">
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Name: activate to sort column ascending"
                                                    style={{ width: "80px" }}
                                                >
                                                    STT
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Name: activate to sort column ascending"
                                                    style={{ width: "220px" }}
                                                >
                                                    USER
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Gender: activate to sort column ascending"
                                                >
                                                    NGÂN HÀNG / GÓI VIP
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Gender: activate to sort column ascending"
                                                >
                                                    LOẠI
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Education: activate to sort column ascending"
                                                >
                                                    NGÀY ĐĂNG KÝ
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Mobile: activate to sort column ascending"
                                                >
                                                    NGÀY NGÀY HẾT HẠN
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.map((item, key) => (
                                                    <tr key={key} role="row" className="odd">
                                                        <td>
                                                            <div className="d-flex text-warning">
                                                                {(page - 1) * perPage + key + 1}
                                                            </div>
                                                        </td>
                                                        <td className='text-warning'>
                                                            <div className='row'>
                                                                <div className='col-12'>
                                                                    {item.type == 1 ? (
                                                                        <>
                                                                            <span className='text-primary'>{item.bank_username}</span> <br />
                                                                            <span className='text-primary'>{item.bank_number}</span> <br />
                                                                            <div className='text-danger'>{item.user_name}</div>
                                                                        </>
                                                                    ) : item.type == 2 ? (
                                                                        <>
                                                                            <span className='text-primary'>{item.user.name}</span> <br />
                                                                            <div className='text-danger'>{item.user.user_name}</div>
                                                                        </>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='text-warning'>
                                                            {item.type == 1 ? (
                                                                <>
                                                                    {item.name}
                                                                </>
                                                            ) : item.type == 2 ? (
                                                                <>
                                                                    {{
                                                                        vip1: "Gói Vip 1",
                                                                        vip2: "Gói Vip 2",
                                                                        vip3: "Gói Vip 3"
                                                                    }[item.bill_type] || ""}
                                                                </>
                                                            ) : null}
                                                        </td>
                                                        <td>
                                                            {
                                                                item.type === '1' ? <span className='text-info'>Tài khoản ngân hàng</span>
                                                                    : <span className='text-warning'>Gói package bill</span>
                                                            }
                                                        </td>
                                                        <td className='text-warning'>{item.start_day}</td>
                                                        <td className={item.is_expired == 1 ? 'text-success' : 'text-danger'}>
                                                            <div style={{ fontWeight: 600 }}>{item.end_day}</div>
                                                            {item.type == 1 && (
                                                                <div className="d-flex gap-1 mt-1">
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-xs btn-outline-danger" 
                                                                        onClick={() => handleResetExpiry(item.id, 1, item.bank_number || item.bank_username)}
                                                                        title="Reset ngày hết hạn về còn 1 ngày"
                                                                    >
                                                                        1 Ngày
                                                                    </button>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-xs btn-outline-warning" 
                                                                        onClick={() => handleResetExpiry(item.id, 3, item.bank_number || item.bank_username)}
                                                                        title="Reset ngày hết hạn về còn 3 ngày"
                                                                    >
                                                                        3 Ngày
                                                                    </button>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn btn-xs btn-success text-white" 
                                                                        onClick={() => handleAdminRenew(item.id, item.bank_number || item.bank_username, item.user_name || item.username, item.end_day)}
                                                                        title="Gia hạn thời hạn tài khoản hộ user"
                                                                        style={{ fontWeight: 600, padding: '2px 8px' }}
                                                                    >
                                                                        + Gia hạn
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <Paginate meta={meta} changePage={changePage} page={page} handleSetPage={handleSetPage} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MasterLayout>
    );
}

export default PackagePage;